import {AddressBean, addressSchema} from '@/service/model/AddressBean'
import {LocationBean, locationSchema} from '@/service/model/LocationBean'
import {JSONSchemaType} from 'ajv'
import {isSameLocation} from '@/utils/GeoFormatters'

export interface SiteDeliveryAddressBean extends AddressBean {
  label?: string | null
  name?: string | null
  reference?: string | null
  location?: LocationBean | null
}

export interface SiteBean extends AddressBean {
  id: string
  name: string
  reference?: string | null
  
  location?: LocationBean | null
  inExclusivityZone?: boolean
  addresses?: Array<SiteDeliveryAddressBean> | null
  delivery_addresses?: Array<SiteDeliveryAddressBean> | null
  deliveryAddresses?: Array<SiteDeliveryAddressBean> | null
}

export function isSameSite(site?: SiteBean | null, other?: SiteBean | null): boolean {
  if (site?.id !== other?.id) {
    return false
  }
  if (site?.name !== other?.name) {
    return false
  }
  if (site?.reference !== other?.reference) {
    return false
  }
  // noinspection RedundantIfStatementJS
  if (!isSameLocation(site?.location, other?.location)) {
    return false
  }
  return true
}

export const siteDeliveryAddressSchema: JSONSchemaType<SiteDeliveryAddressBean> = {
  type: 'object',
  properties: {
    ...addressSchema.properties,
    label: {
      type: ['string'],
      nullable: true
    },
    name: {
      type: ['string'],
      nullable: true
    },
    reference: {
      type: ['string'],
      nullable: true
    },
    location: {
      ...locationSchema,
      type: ['object'],
      nullable: true
    }
  },
  additionalProperties: true
}

export const siteSchema: JSONSchemaType<SiteBean> = {
  type: 'object',
  properties: {
    id: {
      type: ['string']
    },
    name: {
      type: ['string']
    },
    reference: {
      type: ['string'],
      nullable: true
    },
    ...addressSchema.properties,
    location: {
      ...locationSchema,
      type: ['object'],
      nullable: true
    },
    inExclusivityZone: {
      type: 'boolean',
      nullable: true
    },
    addresses: {
      type: 'array',
      items: siteDeliveryAddressSchema,
      nullable: true
    },
    delivery_addresses: {
      type: 'array',
      items: siteDeliveryAddressSchema,
      nullable: true
    },
    deliveryAddresses: {
      type: 'array',
      items: siteDeliveryAddressSchema,
      nullable: true
    }
  },
  required: ['id', 'name'],
  additionalProperties: true
}

export const siteManagerSiteArraySchema: JSONSchemaType<Array<SiteBean>> = {
  type: 'array',
  items: siteSchema
}
